import { XSMALL, SMALL, MEDIUM, LARGE, XLARGE } from '../../../../../constants/font/breakpoints';

export const fontSizeByDevice = {
  [XSMALL]: {
    xsmall: 12,
    small: 14,
    medium: 16,
    mlarge: 18,
    large: 22,
    xlarge: 28,
    xxlarge: 32,
    xxxlarge: 40,
    jumbo: 44,
    xjumbo: 48,
    xxjumbo: 64
  },
  [SMALL]: {
    xsmall: 12,
    small: 14,
    medium: 16,
    mlarge: 18,
    large: 22,
    xlarge: 30,
    xxlarge: 38,
    xxxlarge: 48,
    jumbo: 62,
    xjumbo: 72,
    xxjumbo: 80
  },
  [MEDIUM]: {
    xsmall: 12,
    small: 14,
    medium: 16,
    mlarge: 18,
    large: 22,
    xlarge: 30,
    xxlarge: 38,
    xxxlarge: 48,
    jumbo: 62,
    xjumbo: 72,
    xxjumbo: 96
  },
  [LARGE]: {
    xsmall: 12,
    small: 14,
    medium: 16,
    mlarge: 18,
    large: 22,
    xlarge: 32,
    xxlarge: 44,
    xxxlarge: 62,
    jumbo: 72,
    xjumbo: 96,
    xxjumbo: 112
  },
  [XLARGE]: {
    xsmall: 14,
    small: 16,
    medium: 18,
    mlarge: 20,
    large: 24,
    xlarge: 36,
    xxlarge: 48,
    xxxlarge: 64,
    jumbo: 74,
    xjumbo: 98,
    xxjumbo: 120
  }
};
